import { render, staticRenderFns } from "./ComplaintFollowUpAdd.vue?vue&type=template&id=7c6278af&"
import script from "./ComplaintFollowUpAdd.vue?vue&type=script&lang=js&"
export * from "./ComplaintFollowUpAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports